import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import EntetesFactures from './entetesFactures';
import DetailsFactures from './detailsFactures';
import { getFactures, getVentes, getDetailsVentes } from '../../../data/factures';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Factures = () => {
  const [factures, setFactures] = useState([]);
  const [ventes, setVentes] = useState([]);
  const [detailsVentes, setDetailsVentes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingDetailsVentes, setLoadingDetailsVentes] = useState(false);
  const [selectedFactures, setSelectedFactures] = useState([]);
  const { user } = useSelector(state => state.auth);
  const [condition, setCondition] = useState({
    date: [
      new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
      new Date(Date.now()).toISOString(),
    ],
    magasin: user.magasin === 'Tous' ? 'Tous' : user.magasin,
  });
  const location = useLocation();

  useEffect(() => {
    const fetchAll = async () => {
      setLoadingDetailsVentes(true);
      setVentes([]);
      setDetailsVentes([]);
      const [dataVentes, dataDetailsVentes] = await Promise.all([
        getVentes(selectedFactures),
        getDetailsVentes(selectedFactures),
      ]);

      setVentes(dataVentes);
      setDetailsVentes(dataDetailsVentes);
      setLoadingDetailsVentes(false);
    };

    // const recupVentes = async () => {
    //   console.log(selectedFactures[0].magasin);
    //   const ventes = await getVentes(selectedFactures);
    //   console.log('ventes :', ventes);
    //   setVentes(ventes);
    // };
    // const recupDetailsVentes = async () => {
    //   const detailsVentes = await getDetailsVentes(selectedFactures);
    //   setDetailsVentes(detailsVentes);
    // };

    if (selectedFactures.length > 0) {
      fetchAll();
    }
  }, [selectedFactures]);

  useEffect(() => {
    const recupFactures = async () => {
      setLoading(true);
      try {
        const factures = await getFactures(condition);
        setFactures(factures);
      } catch (error) {
        toast.error('Erreur lors de la récupération des factures');
      } finally {
        setLoading(false);
      }
    };
    recupFactures();
  }, [condition]);

  // useEffect(() => {
  //   console.log(location.pathname);
  // }, [location]);

  return (
    <Row style={{ minHeight: '90vh' }}>
      <Col xs={4} md={4} sm={4} style={{ paddingRight: '15px' }}>
        <EntetesFactures
          factures={factures}
          loading={loading}
          setCondition={setCondition}
          setSelectedFactures={setSelectedFactures}
          selectedFactures={selectedFactures}
        />
      </Col>
      <Col xs={8} md={8} sm={8} style={{ paddingLeft: '0px' }}>
        <DetailsFactures
          selectedFactures={selectedFactures}
          setSelectedFactures={setSelectedFactures}
          ventes={ventes}
          detailsVentes={detailsVentes}
          loading={loadingDetailsVentes}
        />
      </Col>
    </Row>
  );
};

export default Factures;
